// Ícones ativos usam o par preenchido explícito, preservando o catálogo legado.
// Literais garantem que o Tailwind emita o CSS; não montar sufixos em runtime.
// Valores fora do mapa mantêm a identidade recebida.
export const ICON_LINE_TO_FILL = {
  'i-ph-envelope': 'i-ph-envelope-fill',
  'i-ph-clock': 'i-ph-clock-fill',
  'i-ph-circle': 'i-ph-circle-fill',
  'i-ph-user': 'i-ph-user-fill',
  'i-ph-tray': 'i-ph-tray-fill',
  'i-ph-radio-button': 'i-ph-radio-button-fill',
  'i-ph-stack': 'i-ph-stack-fill',
  'i-ph-check-circle': 'i-ph-check-circle-fill',
  'i-ph-calendar-check': 'i-ph-calendar-check-fill',
  'i-ph-lightning': 'i-ph-lightning-fill',
  'i-ph-kanban': 'i-ph-kanban-fill',
  'i-ph-folder': 'i-ph-folder-fill',
  'i-ph-folder-open': 'i-ph-folder-open-fill',
  'i-ph-star': 'i-ph-star-fill',
  'i-ph-flag': 'i-ph-flag-fill',
  'i-ph-bookmark': 'i-ph-bookmark-fill',
  'i-ph-tag': 'i-ph-tag-fill',
  'i-ph-heart': 'i-ph-heart-fill',
  'i-ph-calendar': 'i-ph-calendar-fill',
  'i-ph-bell': 'i-ph-bell-fill',
  'i-ph-fire': 'i-ph-fire-fill',
  'i-ph-target': 'i-ph-target-fill',
  'i-ph-trophy': 'i-ph-trophy-fill',
  'i-ph-currency-dollar': 'i-ph-currency-dollar-fill',
  'i-ph-house': 'i-ph-house-fill',
  'i-ph-briefcase': 'i-ph-briefcase-fill',
  'i-ph-users': 'i-ph-users-fill',
  'i-ph-chat-circle': 'i-ph-chat-circle-fill',
  'i-ph-phone': 'i-ph-phone-fill',
  'i-ph-funnel': 'i-ph-funnel-fill',
  'i-ph-push-pin': 'i-ph-push-pin-fill',
  'i-ph-hash': 'i-ph-hash-fill',
  'i-ph-archive': 'i-ph-archive-fill',
  'i-ri-account-box-line': 'i-ri-account-box-fill',
  'i-ri-alarm-line': 'i-ri-alarm-fill',
  'i-ri-alarm-warning-line': 'i-ri-alarm-warning-fill',
  'i-ri-apps-2-line': 'i-ri-apps-2-fill',
  'i-ri-bank-card-line': 'i-ri-bank-card-fill',
  'i-ri-bar-chart-grouped-line': 'i-ri-bar-chart-grouped-fill',
  'i-ri-book-line': 'i-ri-book-fill',
  'i-ri-book-shelf-line': 'i-ri-book-shelf-fill',
  'i-ri-box-3-line': 'i-ri-box-3-fill',
  'i-ri-briefcase-line': 'i-ri-briefcase-fill',
  'i-ri-building-2-line': 'i-ri-building-2-fill',
  'i-ri-calendar-2-line': 'i-ri-calendar-2-fill',
  'i-ri-calendar-schedule-line': 'i-ri-calendar-schedule-fill',
  'i-ri-chat-1-line': 'i-ri-chat-1-fill',
  'i-ri-chat-3-line': 'i-ri-chat-3-fill',
  'i-ri-chat-quote-line': 'i-ri-chat-quote-fill',
  'i-ri-checkbox-blank-circle-line': 'i-ri-checkbox-blank-circle-fill',
  'i-ri-checkbox-circle-line': 'i-ri-checkbox-circle-fill',
  'i-ri-code-line': 'i-ri-code-fill',
  'i-ri-contacts-line': 'i-ri-contacts-fill',
  'i-ri-dashboard-line': 'i-ri-dashboard-fill',
  'i-ri-draft-line': 'i-ri-draft-fill',
  'i-ri-edit-line': 'i-ri-edit-fill',
  'i-ri-facebook-line': 'i-ri-facebook-fill',
  'i-ri-filter-line': 'i-ri-filter-fill',
  'i-ri-flashlight-line': 'i-ri-flashlight-fill',
  'i-ri-git-branch-line': 'i-ri-git-branch-fill',
  'i-ri-government-line': 'i-ri-government-fill',
  'i-ri-group-line': 'i-ri-group-fill',
  'i-ri-history-line': 'i-ri-history-fill',
  'i-ri-hourglass-line': 'i-ri-hourglass-fill',
  'i-ri-inbox-line': 'i-ri-inbox-fill',
  'i-ri-instagram-line': 'i-ri-instagram-fill',
  'i-ri-install-line': 'i-ri-install-fill',
  'i-ri-keyboard-line': 'i-ri-keyboard-fill',
  'i-ri-layout-grid-line': 'i-ri-layout-grid-fill',
  'i-ri-lifebuoy-line': 'i-ri-lifebuoy-fill',
  'i-ri-lightbulb-line': 'i-ri-lightbulb-fill',
  'i-ri-line-chart-line': 'i-ri-line-chart-fill',
  'i-ri-lock-line': 'i-ri-lock-fill',
  'i-ri-mail-line': 'i-ri-mail-fill',
  'i-ri-megaphone-line': 'i-ri-megaphone-fill',
  'i-ri-palette-line': 'i-ri-palette-fill',
  'i-ri-price-tag-2-line': 'i-ri-price-tag-2-fill',
  'i-ri-price-tag-line': 'i-ri-price-tag-fill',
  'i-ri-radio-button-line': 'i-ri-radio-button-fill',
  'i-ri-repeat-line': 'i-ri-repeat-fill',
  'i-ri-robot-line': 'i-ri-robot-fill',
  'i-ri-rocket-line': 'i-ri-rocket-fill',
  'i-ri-search-line': 'i-ri-search-fill',
  'i-ri-settings-line': 'i-ri-settings-fill',
  'i-ri-share-2-line': 'i-ri-share-2-fill',
  'i-ri-shield-check-line': 'i-ri-shield-check-fill',
  'i-ri-shield-line': 'i-ri-shield-fill',
  'i-ri-shut-down-line': 'i-ri-shut-down-fill',
  'i-ri-stack-line': 'i-ri-stack-fill',
  'i-ri-time-line': 'i-ri-time-fill',
  'i-ri-user-follow-line': 'i-ri-user-follow-fill',
  'i-ri-user-line': 'i-ri-user-fill',
  'i-ri-user-settings-line': 'i-ri-user-settings-fill',
};

/**
 * Devolve a variante preenchida do ícone quando o item está ativo/selecionado.
 *
 * Troca ícones Phosphor e Remix que tenham par preenchido explícito no catálogo.
 * Qualquer outra coisa (ícone já preenchido, `i-woot-*`, `i-logos-*`,
 * `i-lucide-*`, componente/VNode passado como ícone, ou Remix sem par) sai
 * exatamente como entrou.
 *
 * @param {string|Object|Function} icon ícone declarado pelo item de navegação
 * @param {boolean} isActive item está ativo/selecionado
 * @returns {string|Object|Function} ícone a renderizar
 */
export const resolveActiveIcon = (icon, isActive) => {
  if (!isActive || typeof icon !== 'string') return icon;
  return ICON_LINE_TO_FILL[icon] ?? icon;
};
